import type { ExtractPropTypes } from "vue";
import type { LayoutProps } from "../../main/index";

export const ModulePropsOption = {
    origin: { type: Object as PropType<LayoutProps>, required: true },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;

export interface ModuleReference {
    id: string;
    name: string;
    tissue: string;
    cells: string;
    species: string;
    visible?: boolean;
    descript: string;
    sequences: string[];
}

export interface ModulePMID {
    id: string;
    name: string;
    descript: string;
}

export interface ModuleAmino {
    name: string;
    cell: string;
    pmids: ModulePMID[];
    tissue: string;
    species: string;
    sequence: string;
}

export interface ModuleInfo {
    mode: string;
    index: number;
    score: string;
    effect: string;
    target: string;
    aminos: ModuleAmino[];
    references: ModuleReference[];
    mechanisms: string;
    effect_name: string;
    effect_id: string;
    target_name: string;
    target_id: string;
    regulation_mode: string;
    regulatory_detail: string;
}

export interface ModuleData {
    count: number;
    page: number;
    data: ModuleInfo[];
    filters: any;
}
